import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=33c130ef&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33c130ef')) {
      api.createRecord('33c130ef', component.options)
    } else {
      api.reload('33c130ef', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=33c130ef&", function () {
      api.rerender('33c130ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2JhefK18wMHlp/JS/comp/ErrorMessage.vue"
export default component.exports